<div class="echarts" id="charts" echarts [options]="chartOption" (chartInit)="onChartInit($event)"
  (chartDataZoom)="onDataZoom()" *ngIf="lineData?.length else noData"></div>
<ng-template #noData>
  <div class="place-center h-100 no-data-style">No Data</div>
</ng-template>